module.exports = __webpack_public_path__ + "img/sustainability@2x.4f59a0f.jpg";